// AUTO-GENERATED by scripts/gen-build-info.js on prebuild/prestart. Do not edit by hand.
export const BUILD_COMMIT = "e85b966";
export const BUILD_BRANCH = "HEAD";
export const BUILD_TIME = "2026-11-03T22:27:56.671Z";
